import {
    GETWITHDRWALCOUNT_SUCCESS,
    GETWITHDRWALCOUNT_FAILED,
    RESET_GETWITHDRWALCOUNT,
    LOADING_GETWITHDRWALCOUNT,
    NETWORK_ERROR_GETWITHDRWALCOUNT,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETWITHDRWALCOUNT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETWITHDRWALCOUNT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETWITHDRWALCOUNT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETWITHDRWALCOUNT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETWITHDRWALCOUNT:
            return (state = initialState);
        default:
            return state;
    }
};
